export default "__VITE_ASSET__XurAgvQs__"